import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { PrintModalComponent } from './print-modal.component';

@Injectable({
	providedIn: 'root',
})
export class PrintModalService {
	constructor(private modalService: NgbModal) {}

	public openModal$(
		html: string,
		printHeader: string = null,
		modalTitle: string = 'Print',
	) {
		return new Observable<boolean>((o) => {
			const ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				size: 'lg',
				scrollable: true,
				windowClass: 'modal-primary',
			};
			const modal = this.modalService.open(
				PrintModalComponent,
				ngbModalOptions,
			);

			(modal.componentInstance as PrintModalComponent).bindModalData({
				html: html,
				opts: { printHeader: printHeader, modalTitle: modalTitle },
			});

			modal.result
				.then(() => {
					o.next(true);
					o.complete();
				})
				.catch(() => {
					o.next(false);
					o.complete();
				});
		});
	}
}
